import { FormGroup, TextField, styled as materialStyled } from "@mui/material";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";

interface Props {
    image: string;
    onChangeImage: (image: string) => void;
}

const smallCss = {
    "& .MuiOutlinedInput-input": {
        padding: "10px 10px 10px 10px",
        fontSize: "13px",
        minWidth: "180px",
        backgroundColor: "white",
    },
};
const CssTextField = materialStyled(TextField)(smallCss);

export default function OrganizationChannelSettingsEngine({ image, onChangeImage }: Props): JSX.Element {
    return (
        <FormGroup style={{ width: "100%" }}>
            <HESPFormLabel label="Default engine image" description="Leave empty if latest should be used" />
            <CssTextField
                fullWidth
                type="text"
                size="small"
                placeholder="Image to use"
                onChange={(e) => onChangeImage(e.target.value)}
                variant="outlined"
                key="engine-image"
                value={image}
            />
        </FormGroup>
    );
}
